/*** IMPORTS FROM imports-loader ***/
var define = false;

export default {
	init: (app, Swiper) => {
		/*
		|
		| Constants
		|-----------
		*/
        const
            $body         		   = $('body'),
            $swipers      		   = $('.swiper'),
            $flexibleWysiwygSimple = $('.flexible-wysiwyg-simple'),
            $flexibleContentVisibleHidden = $('.flexible-content-visible-hidden')
		;

		/*
		|
		| Swiper (Simple)
		|-----------
		*/
		const
			$swipersSimple = $('[data-slider="simple"]')
		;

		$.each( $swipersSimple, (index, element) => {

			const type = element.dataset.slider
			const count = element.dataset.count
			const id = $( element ).attr('id', `${ type }-${ index + 1 }`).attr('id')

			let swiperOptions = {}

			if (count > 1) {

				swiperOptions.loop = true
				swiperOptions.navigation = {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev',
				}
				
			}

			const swiper = new Swiper( `#${ id }`, swiperOptions);


		});


		/*
		|
		| Wysiwyg Simple
		|-----------
		*/
		if ( $flexibleWysiwygSimple.length ) {

			$.each( $flexibleWysiwygSimple, (index, element) => {

				let
					$cms  = $(element).find('.cms'),
					$imgs = $cms.find('img')
				;

				$.each($imgs, (index, element) => {

					if ( $(element).parent().is('p') ) {

						$(element).parent().addClass('img-ar-in-p');
						
					} else {
						
						$(element).parent().addClass('img-ar');

					}

				});

			});
			
		}

		/*
		|
		| Wysiwyg Hidden
		|-----------
		*/
		if ( $flexibleContentVisibleHidden.length ) {

			$.each( $flexibleContentVisibleHidden, (index, element) => {

				let
					$cta  	   = $(element).find('a[href="#hiddenwysiwyg"]'),
					$cmsHidden = $(element).find('.cms.hidden')
				;

				$cta.on('click', (e) => {

					e.preventDefault();

					$cmsHidden.addClass('visible');
					$cta.css({
						'height' : '0',
						'opacity' : '0',
						'visibility' : 'hiddden',
					})

					setTimeout(() => {
						$cta.css({
							'display': 'none'
						})
					}, 300);

				});

			});
			
		}

		/*
        |
        |  Anchors (on Load = From another page)
        |---------------------
        |*/
        if ( window.location.hash.length ) {
            
            let
                hash,
                target,
                targetOffsetTop,
                headerOffsetTop = $('#header').outerHeight(),
                offset
            ;


            hash = window.location.hash;

            window.location.hash = '';
            history.replaceState(null, null, ' ')

            target = $(hash);

            if ( target.length ) {

                targetOffsetTop = target.offset().top;

                offset = (headerOffsetTop != null) ? targetOffsetTop - headerOffsetTop + 1 : targetOffsetTop - 100;

                $('html, body').animate({

                    scrollTop: offset
    
                }, 1000);
                
            }
            
        }


        $body.on('loaderEnd', () => console.log('ended'))
	}
}
